var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultThemeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30501",
    "data-name": "Group 30501",
    transform: "translate(10704 -17338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30485",
    "data-name": "Group 30485"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14180",
    "data-name": "Rectangle 14180",
    width: 32,
    height: 32,
    transform: "translate(-10704 17338)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aperture",
    transform: "translate(-10698 17343.977)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1008",
    "data-name": "Ellipse 1008",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2.001 2.023)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1025",
    "data-name": "Line 1025",
    x2: 4.599,
    y2: 7.964,
    transform: "translate(11.862 6.807)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1026",
    "data-name": "Line 1026",
    x2: 9.197,
    transform: "translate(8.161 6.807)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1027",
    "data-name": "Line 1027",
    y1: 7.964,
    x2: 4.599,
    transform: "translate(6.31 2.048)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1028",
    "data-name": "Line 1028",
    x1: 4.599,
    y1: 7.964,
    transform: "translate(3.562 5.253)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1029",
    "data-name": "Line 1029",
    x1: 9.197,
    transform: "translate(2.665 13.216)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1030",
    "data-name": "Line 1030",
    x1: 4.599,
    y2: 7.964,
    transform: "translate(9.114 10.012)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultThemeActive);
export default __webpack_public_path__ + "static/media/defaultThemeActive.36abcf1a.svg";
export { ForwardRef as ReactComponent };